"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@epic-ui/icons");
var Fade_1 = __importDefault(require("@material-ui/core/Fade"));
var utils_1 = require("@material-ui/utils");
exports.createProps = function (options) {
    if (options === void 0) { options = {}; }
    var defaultProps = {
        MuiAlert: {
            variant: "filled",
            iconMapping: { success: React.createElement(icons_1.AlertOutline, null) },
        },
        MuiButton: {
            variant: "contained",
            color: "primary",
            disableElevation: true,
        },
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiButtonGroup: {
            variant: "contained",
            color: "primary",
            disableRipple: true,
        },
        MuiCheckbox: {
            color: "primary",
            checkedIcon: React.createElement(icons_1.CheckboxChecked, null),
            indeterminateIcon: React.createElement(icons_1.CheckboxIndeterminate, null),
            icon: React.createElement(icons_1.CheckboxUnchecked, null),
        },
        MuiDialogTitle: {
            disableTypography: true,
        },
        MuiInputAdornment: {
            disableTypography: true,
        },
        MuiList: {
            disablePadding: true,
        },
        MuiLink: {
            color: "textPrimary",
            underline: "always",
        },
        MuiOutlinedInput: {
            notched: false,
        },
        MuiTextField: {
            variant: "outlined",
        },
        MuiMenu: {
            elevation: 0,
            TransitionComponent: Fade_1.default,
            PaperProps: {
                variant: "outlined",
            },
        },
        MuiPagination: {
            shape: "rounded",
        },
        MuiSelect: {
            variant: "outlined",
            MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
                // There is no className linking dropdown menu to the MuiSelect. This is how to style only for `MuiSelect`.
                PaperProps: {
                    variant: "outlined",
                    style: {
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        transform: "translateY(-1px)",
                    },
                },
            },
        },
        MuiSwitch: {
            color: "primary",
        },
        MuiRadio: {
            color: "primary",
            checkedIcon: React.createElement(icons_1.RadioButtonChecked, null),
            icon: React.createElement(icons_1.RadioButtonUnchecked, null),
        },
        MuiTableSortLabel: {
            IconComponent: icons_1.ChevronDown,
        },
    };
    return utils_1.deepmerge(defaultProps, options, { clone: false });
};
//# sourceMappingURL=createProps.js.map